import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import * as React from 'react';
import { arrayDelete, arrayPush } from '../utils/helpers/array.js';

/* eslint-disable @typescript-eslint/no-explicit-any */
var joinObjectArrayProperty = function joinObjectArrayProperty(arr, key, renderer) {
  var delimiter = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ', ';
  return arr.map(function (node) {
    return renderer ? renderer(node) : node[key];
  }).join(delimiter);
};
var draftEvent = function draftEvent(value, name) {
  return {
    target: {
      name: name,
      value: value
    },
    currentTarget: {
      name: name,
      value: value
    }
  };
};
var ELEMENTAL_SELECT_ALL_VALUE = '__elemental_select_all';
function useSelectAll(initialItems, selected, selectAllLabel) {
  var items = React.useMemo(function () {
    if (selectAllLabel) {
      return [{
        name: selectAllLabel,
        value: ELEMENTAL_SELECT_ALL_VALUE
      }].concat(_toConsumableArray(initialItems));
    } else {
      return initialItems;
    }
  }, [initialItems, selectAllLabel]);
  var selectedItems = React.useMemo(function () {
    return items.filter(function (item) {
      if (item.value === ELEMENTAL_SELECT_ALL_VALUE && Array.isArray(selected) && selected.length === initialItems.length) {
        return true;
      } else {
        return Array.isArray(selected) ? selected.includes(item.value) : selected === item.value;
      }
    });
  }, [items, selected, initialItems]);

  // we don't want to display "Select all" in the label
  var selectedItemsWithoutAll = React.useMemo(function () {
    return items.filter(function (item) {
      return Array.isArray(selected) ? selected.includes(item.value) : selected === item.value;
    });
  }, [items, selected]);
  var getNewValue = React.useCallback(function (value) {
    // istanbul ignore else
    if (Array.isArray(selected)) {
      if (value === ELEMENTAL_SELECT_ALL_VALUE && selected.length !== initialItems.length) {
        return initialItems.map(function (item) {
          return item.value;
        });
      } else if (value === ELEMENTAL_SELECT_ALL_VALUE) {
        return [];
      } else {
        return selected.includes(value) ? arrayDelete(selected, value) : arrayPush(selected, value);
      }
    } else if (!Array.isArray(selected)) {
      return value;
    } else {
      // istanbul ignore next
      console.warn('Select component was provided conflicting selected and multiselect values! Use SelectValueType[] with multiselect, SelectValueType without multiselect!');
    }
  }, [selected, initialItems]);
  return {
    items: items,
    selectedItems: selectedItems,
    selectedItemsWithoutAll: selectedItemsWithoutAll,
    getNewValue: getNewValue
  };
}

export { draftEvent, joinObjectArrayProperty, useSelectAll };
